import { render, staticRenderFns } from "./stocks.vue?vue&type=template&id=20e6942a&scoped=true&lang=pug&"
import script from "./stocks.vue?vue&type=script&lang=js&"
export * from "./stocks.vue?vue&type=script&lang=js&"
import style0 from "./stocks.vue?vue&type=style&index=0&id=20e6942a&lang=scss&scoped=true&"
import style1 from "./stocks.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20e6942a",
  null
  
)

export default component.exports